"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUrlObject = void 0;
const toUrlObject = (urlLike) => {
    if (urlLike instanceof URL)
        return urlLike;
    return new URL(urlLike, window.location.href);
};
exports.toUrlObject = toUrlObject;
